import React from 'react';
import { usePageContext } from 'vike-react/usePageContext';
import { FlexiblePageRenderer } from '@/pages/render/flexiblePages/FlexiblePageRenderer';

export function Page() {
  const pageContext = usePageContext();
  const pageId = pageContext.routeParams.treeId;

  return <FlexiblePageRenderer pageId={pageId} />;
}
